import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import router from '@/router/index.js';
import authService from '@/service/authService';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'));
  const userRole = ref(localStorage.getItem('role'));

  const isAuthenticated = computed(() => !!token.value);

  function setAuthData(data) {
    token.value = data.token;
    const normalizedRole = data.role.startsWith('ROLE_') ? data.role : `ROLE_${data.role}`;
    userRole.value = normalizedRole;
    authService.handleLoginSuccess(data);
  }

  async function login(credentials) {
    const result = await authService.login(credentials);
    if (result.success) {
      setAuthData(result);
    }
    return result;
  }

  async function loginWithGoogle(googleData) {
    const result = await authService.loginWithGoogle(googleData);
    if (result.success) {
      setAuthData(result);
    }
    return result;
  }

  function logout() {
    token.value = null;
    userRole.value = null;
    authService.logout();
    router.push('/');
  }

  return {
    token,
    userRole,
    isAuthenticated,
    login,
    loginWithGoogle,
    logout,
    setAuthData,
  };
});